import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractUtilities } from 'src/app/data/model/contract-utilities';
import { TaggableResource } from 'src/app/data/model/tag-resource';

@Component({
  standalone: false,
  selector: 'app-contract-data-dialog',
  templateUrl: './contract-data-dialog.component.html',
  styleUrls: ['./contract-data-dialog.component.scss']
})
export class ContractDataDialogComponent implements OnInit {

  public get displayedColumns(): string[] {
    return ['idcli', 'name', 'tax/vat', 'type', 'group'];
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContractDialogParams
  ) { }


  ngOnInit(): void {
    console.log(this.data);
  }
  

}
export type ContractDialogParams = {
  data: ContractUtilities[]
  resource: TaggableResource
};
